import api from '../../api/property.api';
import * as types from '../types';
import history from '../../helper/history';

export const setFilter = (filter) => {
  return { type: types.PROPERTY_SET_FILTER, data: filter };
};

export const setProperties = (properties) => {
  return { type: types.PROPERTY_SET_LIST, data: properties };
};

export const setPropertiesCount = (count) => {
  return { type: types.PROPERTY_SET_COUNT, data: count };
};

export const setListLoading = (isLoading) => {
  return { type: types.PROPERTY_SET_LIST_LOADING, data: isLoading };
};

export const setDetailLoading = (isLoading) => {
  return { type: types.PROPERTY_SET_DETAIL_LOADING, data: isLoading };
};

export const setSelectedProperty = (selectedProperty) => {
  return { type: types.PROPERTY_SET_SELECTED_PROPERTY, data: selectedProperty };
};

export const setPagination = (from = 0) => {
  return { type: types.PROPERTY_SET_FROM_FILTER, data: from };
};

export const setSort = (sort) => {
  return { type: types.PROPERTY_SET_SORT_FILTER, data: sort };
};

export const setRegion = (region) => {
  return { type: types.PROPERTY_SET_REGION_FILTER, data: region };
};

export const setAdvisorName = (advisorName) => {
  return { type: types.PROPERTY_SET_ADVISOR_NAME_FILTER, data: advisorName };
};

export const setPropertyCode = (propertyCode) => {
  return { type: types.PROPERTY_SET_PROPERTY_CODE_FILTER, data: propertyCode };
};

export const setTransactionType = (transactionType) => {
  return { type: types.PROPERTY_SET_TRANSACTION_TYPE_FILTER, data: transactionType };
};

export const setPropertyType = (propertyType) => {
  return { type: types.PROPERTY_SET_PROPERTY_TYPE_FILTER, data: propertyType };
};

export const setBedrooms = (bedrooms) => {
  return { type: types.PROPERTY_SET_BEDROOMS_FILTER, data: bedrooms };
};

export const setBedroomExactly = (bedroomExactly) => {
  return { type: types.PROPERTY_SET_BEDROOMS_EXACTLY_FILTER, data: bedroomExactly };
};

export const setFoundationFrom = (foundationFrom) => {
  return { type: types.PROPERTY_SET_FOUNDATION_FROM_FILTER, data: foundationFrom };
};

export const setFoundationTo = (foundationTo) => {
  return { type: types.PROPERTY_SET_FOUNDATION_TO_FILTER, data: foundationTo };
};

export const setAreaFrom = (areaFrom) => {
  return { type: types.PROPERTY_SET_AREA_FROM_FILTER, data: areaFrom };
};

export const setAreaTo = (areaTo) => {
  return { type: types.PROPERTY_SET_AREA_TO_FILTER, data: areaTo };
};

export const setOverallPriceFrom = (overallPriceFrom) => {
  return { type: types.PROPERTY_SET_OVERALL_PRICE_FROM_FILTER, data: overallPriceFrom };
};

export const setOverallPriceTo = (overallPriceTo) => {
  return { type: types.PROPERTY_SET_OVERALL_PRICE_TO_FILTER, data: overallPriceTo };
};

export const setSegmentPriceFrom = (segmentPriceFrom) => {
  return { type: types.PROPERTY_SET_SEGMENT_PRICE_FROM_FILTER, data: segmentPriceFrom };
};

export const setSegmentPriceTo = (segmentPriceTo) => {
  return { type: types.PROPERTY_SET_SEGMENT_PRICE_TO_FILTER, data: segmentPriceTo };
};

export const setFacilities = (facilities) => {
  return { type: types.PROPERTY_SET_FACILITIES_FILTER, data: facilities };
};

export const setParkingSpace = (parkingSpace) => {
  return { type: types.PROPERTY_SET_PARKING_SPACE_FILTER, data: parkingSpace };
};

export const setParkingSpaceExactly = (parkingSpaceExactly) => {
  return { type: types.PROPERTY_SET_PARKING_SPACE_EXACTLY_FILTER, data: parkingSpaceExactly };
};

export const setTotalFloors = (totalFloors) => {
  return { type: types.PROPERTY_SET_TOTAL_FLOORS_FILTER, data: totalFloors };
};

export const setTotalFloorsExactly = (totalFloorsExactly) => {
  return { type: types.PROPERTY_SET_TOTAL_FLOORS_EXACTLY_FILTER, data: totalFloorsExactly };
};

export const setPropertyFloorFrom = (propertyFloorFrom) => {
  return { type: types.PROPERTY_SET_PROPERTY_FLOORS_FROM_FILTER, data: propertyFloorFrom };
};

export const setPropertyFloorTo = (propertyFloorTo) => {
  return { type: types.PROPERTY_SET_PROPERTY_FLOORS_TO_FILTER, data: propertyFloorTo };
};

export const setTotalUnitPerFloors = (totalUnitPerFloors) => {
  return { type: types.PROPERTY_SET_TOTAL_UNIT_PER_FLOORS_FILTER, data: totalUnitPerFloors };
};

export const setTotalUnitPerFloorsExactly = (totalUnitPerFloorsExactly) => {
  return { type: types.PROPERTY_SET_TOTAL_UNIT_PER_FLOORS_EXACTLY_FILTER, data: totalUnitPerFloorsExactly };
};

export const setPropertyUnit = (propertyUnit) => {
  return { type: types.PROPERTY_SET_PROPERTY_UNIT_FILTER, data: propertyUnit };
};

export const setPropertyUnitExactly = (propertyUnitExactly) => {
  return { type: types.PROPERTY_SET_PROPERTY_UNIT_EXACTLY_FILTER, data: propertyUnitExactly };
};

export const setBalcony = (balcony) => {
  return { type: types.PROPERTY_SET_BALCONY_FILTER, data: balcony };
};

export const setCabinet = (cabinet) => {
  return { type: types.PROPERTY_SET_CABINET_FILTER, data: cabinet };
};

export const setFlooring = (flooring) => {
  return { type: types.PROPERTY_SET_FLOORING_FILTER, data: flooring };
};

export const setWarehouse = (warehouse) => {
  return { type: types.PROPERTY_SET_WARE_HOUSE_FILTER, data: warehouse };
};

export const setPropertyDirection = (propertyDirection) => {
  return { type: types.PROPERTY_SET_PROPERTY_DIRECTION_FILTER, data: propertyDirection };
};

export const setPicture = (picture) => {
  return { type: types.PROPERTY_SET_PICTURE_FILTER, data: picture };
};

export const setAdvisorProperties = (properties = []) => {
  return { type: types.PROPERTY_SET_LIST_ADVISOR_PROPERTIES, data: properties };
};

export function fetchProperties(loading = true) {
  return (dispatch, getState) => {
    const {from, length, advisorName, propertyCode, sort, region, transactionType, propertyType, bedrooms, bedroomExactly, foundationFrom, foundationTo, areaFrom, areaTo, overallPriceFrom, overallPriceTo, segmentPriceFrom, segmentPriceTo, facilities, parkingSpace, parkingSpaceExactly, totalFloors, totalFloorsExactly, propertyFloorFrom, propertyFloorTo, totalUnitsPerFloor, totalUnitsPerFloorExactly, propertyUnit, propertyUnitExactly, balcony, cabinet, flooring, wareHouse, propertyDirection, picture} = getState().property.filter;
    const query = `begin=${from}&total=${length}${sort ? `&sort=${sort}` : ''}${region ? `&region=${region}` : ''}${transactionType ? `&transactionType=${transactionType}` : ''}${propertyType ? `&propertyType=${propertyType}` : ''}${bedrooms ? `&bedrooms=${bedrooms}` : ''}${bedroomExactly ? `&bedroomExactly=${bedroomExactly}` : ''}${foundationFrom ? `&foundationFrom=${foundationFrom}` : ''}${foundationTo ? `&foundationTo=${foundationTo}` : ''}${areaFrom ? `&areaFrom=${areaFrom}` : ''}${areaTo ? `&areaTo=${areaTo}` : ''}${overallPriceFrom ? `&overallPriceFrom=${overallPriceFrom}` : ''}${overallPriceTo ? `&overallPriceTo=${overallPriceTo}` : ''}${segmentPriceFrom ? `&segmentPriceFrom=${segmentPriceFrom}` : ''}${segmentPriceTo ? `&segmentPriceTo=${segmentPriceTo}` : ''}${facilities ? `&facilities=${facilities}` : ''}${parkingSpace ? `&parkingSpace=${parkingSpace}` : ''}${parkingSpaceExactly ? `&parkingSpaceExactly=${parkingSpaceExactly}` : ''}${totalFloors ? `&totalFloors=${totalFloors}` : ''}${totalFloorsExactly ? `&totalFloorsExactly=${totalFloorsExactly}` : ''}${propertyFloorFrom ? `&propertyFloorFrom=${propertyFloorFrom}` : ''}${propertyFloorTo ? `&propertyFloorTo=${propertyFloorTo}` : ''}${totalUnitsPerFloor ? `&totalUnitsPerFloor=${totalUnitsPerFloor}` : ''}${totalUnitsPerFloorExactly ? `&totalUnitsPerFloorExactly=${totalUnitsPerFloorExactly}` : ''}${propertyUnit ? `&propertyUnit=${propertyUnit}` : ''}${propertyUnitExactly ? `&propertyUnitExactly=${propertyUnitExactly}` : ''}${balcony ? `&balcony=${balcony}` : ''}${cabinet ? `&cabinet=${cabinet}` : ''}${flooring ? `&flooring=${flooring}` : ''}${wareHouse ? `&wareHouse=${wareHouse}` : ''}${propertyDirection ? `&propertyDirection=${propertyDirection}` : ''}${picture ? `&picture=${picture}`: ''}${advisorName ? `&advisorName=${advisorName}`: ''}${propertyCode ? `&propertyCode=${propertyCode}`: ''}`;

    loading && dispatch(setListLoading(true));
    return api.fetchProperties(query)
        .then(response => {
          dispatch(setProperties(response.result));
          dispatch(setPropertiesCount(response.count));
          dispatch(setListLoading(false));
        })
        .catch(error => {
          if (error.toString() !== 'Cancel') {
            dispatch(setListLoading(false));
          }
          return Promise.reject(error)
        });
  };
}

export function fetchProperty(id, loading = true) {
  return async (dispatch, getState) => {
    if (loading){
      dispatch(setDetailLoading(true));
    }
    return api.fetchProperty(id)
        .then(async response => {
          await dispatch(setSelectedProperty(response));
          dispatch(setDetailLoading(false));
          return response;
        })
        .catch(error => {
          if (error.toString() !== 'Cancel') {
            dispatch(setDetailLoading(false));
            history.replace('not-found');
          }
          return Promise.reject(error);
        });
  }
}

export function addProperty(data) {
  return () => {
    return api.addProperty(data)
        .then(response => response)
        .catch(error => Promise.reject(error));
  }
}

export function fetchPropertiesLocation(lat, long) {
  return (dispatch, getState) => {
    const {advisorName, propertyCode, region, transactionType, propertyType, bedrooms, bedroomExactly, foundationFrom, foundationTo, areaFrom, areaTo, overallPriceFrom, overallPriceTo, segmentPriceFrom, segmentPriceTo, facilities, parkingSpace, parkingSpaceExactly, totalFloors, totalFloorsExactly, propertyFloorFrom, propertyFloorTo, totalUnitsPerFloor, totalUnitsPerFloorExactly, propertyUnit, propertyUnitExactly, balcony, cabinet, flooring, wareHouse, propertyDirection, picture} = getState().property.filter;
    const query = `${lat ? `&lat=${lat}` : ''}${long ? `&long=${long}` : ''}${region ? `&region=${region}` : ''}${transactionType ? `&transactionType=${transactionType}` : ''}${propertyType ? `&propertyType=${propertyType}` : ''}${bedrooms ? `&bedrooms=${bedrooms}` : ''}${bedroomExactly ? `&bedroomExactly=${bedroomExactly}` : ''}${foundationFrom ? `&foundationFrom=${foundationFrom}` : ''}${foundationTo ? `&foundationTo=${foundationTo}` : ''}${areaFrom ? `&areaFrom=${areaFrom}` : ''}${areaTo ? `&areaTo=${areaTo}` : ''}${overallPriceFrom ? `&overallPriceFrom=${overallPriceFrom}` : ''}${overallPriceTo ? `&overallPriceTo=${overallPriceTo}` : ''}${segmentPriceFrom ? `&segmentPriceFrom=${segmentPriceFrom}` : ''}${segmentPriceTo ? `&segmentPriceTo=${segmentPriceTo}` : ''}${facilities ? `&facilities=${facilities}` : ''}${parkingSpace ? `&parkingSpace=${parkingSpace}` : ''}${parkingSpaceExactly ? `&parkingSpaceExactly=${parkingSpaceExactly}` : ''}${totalFloors ? `&totalFloors=${totalFloors}` : ''}${totalFloorsExactly ? `&totalFloorsExactly=${totalFloorsExactly}` : ''}${propertyFloorFrom ? `&propertyFloorFrom=${propertyFloorFrom}` : ''}${propertyFloorTo ? `&propertyFloorTo=${propertyFloorTo}` : ''}${totalUnitsPerFloor ? `&totalUnitsPerFloor=${totalUnitsPerFloor}` : ''}${totalUnitsPerFloorExactly ? `&totalUnitsPerFloorExactly=${totalUnitsPerFloorExactly}` : ''}${propertyUnit ? `&propertyUnit=${propertyUnit}` : ''}${propertyUnitExactly ? `&propertyUnitExactly=${propertyUnitExactly}` : ''}${balcony ? `&balcony=${balcony}` : ''}${cabinet ? `&cabinet=${cabinet}` : ''}${flooring ? `&flooring=${flooring}` : ''}${wareHouse ? `&wareHouse=${wareHouse}` : ''}${propertyDirection ? `&propertyDirection=${propertyDirection}` : ''}${picture ? `&picture=${picture}`: ''}${advisorName ? `&advisorName=${advisorName}`: ''}${propertyCode ? `&propertyCode=${propertyCode}`: ''}`;

    return api.fetchPropertiesLocations(query)
        .then(response => {
          return response.result;
        })
        .catch(error => Promise.reject(error));
  };
}

export function fetchAdvisorProperties(advisor) {
  return (dispatch) => {
    const query = `&advisors=${advisor}`;

    return api.fetchProperties(query)
        .then(response => {
          dispatch(setAdvisorProperties(response.result));
          return response.result;
        })
        .catch(error => Promise.reject(error));
  };
}
